const AttributeTypes = {
    TIPO_STRING: 0,
    TIPO_DECIMAL: 1,
    TIPO_INTEGER: 2,
    TIPO_DATETIME: 3,
    TIPO_BOOLEAN: 4,
    TIPO_TIME: 5
}

export default AttributeTypes;